import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Allservices2 from './Components/Allservices2'; // ✅ import it correctly
import Website from './Components/Website';
import Graphicwork from './Components/Graphicwork';
import Ecommerce from './Components/Ecommerce';
import Software from'./Components/Software';
import Business from './Components/Business';
import Erp from './Components/Erp';
import Search from './Components/Search';
import Digitalmarketing from './Components/Digitalmarketing';
import Socialmedia from'./Components/Socialmedia';
import Lead from './Components/Lead';
import Businessbrand from './Components/Businessbrand';
import Hr from './Components/Hr';
import Privacy from './Components/Privacy';
import About from './Components/About';
import First1 from './Components/First1';
import Form from './Components/Form';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<First1/>} /> 
        <Route path="/allservices2" element={<Allservices2/>} /> 
        <Route path="/website" element={<Website/>} />
        <Route path="/graphicwork" element={<Graphicwork/>} />
        <Route path="/ecommerce" element={<Ecommerce/>} />
        <Route path="/software" element={<Software/>} />
        <Route path="/business" element={<Business/>} />
        <Route path="/erp" element={<Erp/>} />
        <Route path="/search" element={<Search/>}/>
        <Route path="/digitalmarketing" element={<Digitalmarketing/>}/>
        <Route path="/socialmedia" element={<Socialmedia/>}/>
 <Route path="/lead" element={<Lead/>}/>
  <Route path="/businessbrand" element={<Businessbrand/>}/>
   <Route path="/hr" element={<Hr/>}/>
      <Route path="/privacy" element={<Privacy/>}/>
      <Route path="/about" element={<About/>}/>
       <Route path="/first1" element={<First1/>} /> 
       <Route path="/form" element={<Form/>} /> 
      <Route path="/allservices2" element={<Allservices2/>} /> 


      </Routes>
    </Router>
  );
}

export default App;
